import type { MarketTableRecord } from 'ui.table.market';
import { Column } from 'ui.table';
import { treeFactory } from '~/utils/treeFactory';
import type { UseTableContext } from './context';

export const ColumnTree = treeFactory<
  Readonly<Column<MarketTableRecord>>,
  UseTableContext
>();
